<template>
  <div>
    <ProductHeader header="ตั้งราคา" :img_header="header_image" :link_back="$store.state.link_url"/>
    <Product_MakePrice/>
  </div>
</template>

<script>
import ProductHeader from "@/components/admin/manage_products/header_products/ProductHeader.vue";
import Product_MakePrice from "@/components/admin/manage_products/MakePrice/Product_MakePrice.vue";
import HeaderImage from "@/assets/settings.png"
export default {
  name: "ProductMakePrice",
  components: {
    Product_MakePrice,
    ProductHeader
  },
  data() {
    return {
      header_image:HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
